import React from 'react';
import {Button} from 'react-bootstrap';

interface GhgEmissionPeriodsSearchBarProps {
    onCreate: () => void;
    isCreateDisabled: boolean;
}

export const GhgEmissionPeriodsSearchBar = (props: GhgEmissionPeriodsSearchBarProps) => {
    return (
        <div className="electricity-invoices__search-bar bar-position">
            <h2 className="text-light">
                KHG heitkogused
            </h2>
            <div className="card mb-5 shadow">
                <div className="card-body">
                    <div className="d-flex flex-nowrap">
                        <Button className="ml-auto d-flex align-items-center"
                                onClick={props.onCreate}
                                disabled={props.isCreateDisabled}
                                variant={"primary"}>
                            <i className="icon--16 icon__add d-flex mr-1"/>
                            <span>Uus periood</span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
